import { useEffect, useState } from "react";

import { Typography } from "@mui/material";

import { intlFormatDateToHour } from "../../utils/time-utils";

const LiveClock = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setDate(new Date()), 1000);

    return () => clearInterval(interval);
  }, []);

  return <Typography variant={"h4"}>{intlFormatDateToHour(date)}</Typography>;
};

export default LiveClock;
